exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".assignExerciseDetailsForm .smartBookSearch{width:75%;margin-bottom:15px;float:right}.assignExerciseDetailsForm .smartBookSearch .searchBar{margin-left:5px}.assignExerciseDetailsForm input{margin-left:10px!important;vertical-align:text-top!important}.assignExerciseDetailsForm label{margin-bottom:10px!important}.assignExerciseDetailsForm .activityDetailsNote{font-size:small;margin-left:5px;margin-top:20px;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/writing/activities/assign_activity_details_modal.scss
// module id = 1464
// module chunks = 0